const HOST_TW_PROCESSOR = process.env.HOST_TW_PROCESSOR || 'https://userenroll.com'

export default {
  api: '/api',
  cms: '/cms-api',
  tailwindProcessor: `${HOST_TW_PROCESSOR}/tailwind-processor`,
};
